module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recordDaiJia"
  }, [_c('v5-mirco-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "active": _vm.active
    },
    on: {
      "update:active": function($event) {
        _vm.active = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "daijiaContent"
  }, [(_vm.orderList && _vm.orderList.length > 0) ? _c('div', {
    staticClass: "contentList"
  }, _vm._l((_vm.orderList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ListItem",
      on: {
        "click": function($event) {
          return _vm.clickFn(item)
        }
      }
    }, [_c('div', {
      staticClass: "itemContent"
    }, [_c('div', {
      staticClass: "item-row"
    }, [_c('div', {
      staticClass: "itemTime"
    }, [_vm._v(_vm._s(item.orderTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "itemStatus"
    }, [_c('i', {
      staticClass: "iconfont icon-jiantou"
    }), _vm._v(" "), _c('span', {
      staticClass: "text",
      class: item.status === 1 ? 'textRed' : 'textAsh'
    }, [_vm._v(_vm._s(_vm._f("orderStatusFilter")(item.status)))])])]), _vm._v(" "), _c('div', {
      staticClass: "item-time"
    }, [_c('i', {
      staticClass: "iconfont icon-shijian1"
    }), _vm._v(" "), _c('span', {
      staticClass: "site"
    }, [_vm._v(_vm._s(_vm._f("time")(item.book_time)))])]), _vm._v(" "), _c('div', {
      staticClass: "item-address"
    }, [_c('i', {
      staticClass: "yuan"
    }), _vm._v(" "), _c('span', {
      staticClass: "site"
    }, [_vm._v(_vm._s(item.book_address))])]), _vm._v(" "), _c('div', {
      staticClass: "item-address"
    }, [_c('i', {
      staticClass: "yuan color-red"
    }), _vm._v(" "), _c('span', {
      staticClass: "site"
    }, [_vm._v(_vm._s(item.destination))])]), _vm._v(" "), (item.order_no) ? _c('div', {
      staticClass: "item-order"
    }, [_c('span', {
      staticClass: "site"
    }, [_vm._v("订单号：" + _vm._s(item.order_no))])]) : _vm._e()])])
  }), 0) : _c('div', {
    staticClass: "NullOrder"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/yonghu/orderImg.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "imgBut"
  }, [_c('router-link', {
    attrs: {
      "to": "/daijia"
    }
  }, [_vm._v("去下单")])], 1)])]), _vm._v(" "), (_vm.orderList && _vm.orderList.length < _vm.total && _vm.orderList.length > 0) ? _c('div', {
    staticClass: "loadDataBut"
  }, [_c('span', {
    on: {
      "click": _vm.loadDataButFn
    }
  }, [_vm._v("点击加载更多")])]) : _vm._e()]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-276c4df7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderRecord/orderRecord.vue
// module id = 518
// module chunks = 0